var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.$store.getters['online'])?_c('div',{staticClass:"offline-bar"},[_c('div',{staticClass:"offline-label"},[_vm._v(_vm._s(_vm.$t('offline.modals.currently_offline_bar'))+" "),_c('img',{attrs:{"src":require("./../../assets/offline.svg"),"alt":"offline"}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }